import React, { useState } from 'react';
import './AddUnitModal.styles.css';
import apiService from '../../services/api';

const AddUnitModal = ({ isOpen, onClose, onSave }) => {
  const [unitData, setUnitData] = useState({
    name: '',
    shortName: '',
    allowDecimal: false
  });
  const [isSaving, setIsSaving] = useState(false);
  const [apiError, setApiError] = useState(null);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setUnitData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!unitData.name.trim() || !unitData.shortName.trim()) {
      alert('Please fill in all required fields');
      return;
    }

    setIsSaving(true);
    setApiError(null);

    try {
      const payload = {
        actual_name: unitData.name.trim(),
        short_name: unitData.shortName.trim(),
        allow_decimal: unitData.allowDecimal
      };

      const res = await apiService.createUnit(payload);
      const createdUnit = res.data || res;

      if (onSave) {
        onSave(createdUnit);
      }

      setUnitData({ name: '', shortName: '', allowDecimal: false });
      setApiError(null);
      onClose();
    } catch (err) {
      setApiError('Failed to create unit: ' + err.message);
    } finally {
      setIsSaving(false);
    }
  };

  const handleClose = () => {
    setUnitData({ name: '', shortName: '', allowDecimal: false });
    setApiError(null);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={handleClose}>
      <div className="modal" style={{ maxWidth: '540px', width: '95%', borderRadius: '12px', overflow: 'visible', background: 'var(--etpos-card, #fff)', boxShadow: '0 20px 25px -5px rgba(0,0,0,0.1)' }} onClick={(e) => e.stopPropagation()}>
        <div className="modal-header" style={{ padding: '1.25rem 1.5rem', borderBottom: '1px solid #e2e8f0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h3 style={{ margin: 0, fontSize: '1.1rem', fontWeight: '700', color: 'var(--etpos-text, #1e293b)' }}>Add Unit</h3>
          <button onClick={handleClose} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#64748b', fontSize: '1.25rem', lineHeight: 1, padding: '0.25rem' }}>✕</button>
        </div>

        <form onSubmit={handleSubmit}>
          <div style={{ padding: '1.5rem 1.5rem' }}>
            {apiError && (
              <div style={{
                marginBottom: '1rem',
                padding: '0.6rem 0.9rem',
                background: '#fef2f2',
                border: '1px solid #fecaca',
                borderRadius: '6px',
                color: '#991b1b',
                fontSize: '0.85rem'
              }}>
                {apiError}
              </div>
            )}

            <div style={{ marginBottom: '1.25rem' }}>
              <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '600', color: 'var(--etpos-text-muted, #374151)', marginBottom: '0.4rem' }}>
                Name <span style={{ color: '#ef4444' }}>*</span>
              </label>
              <input
                type="text"
                name="name"
                value={unitData.name}
                onChange={handleChange}
                placeholder="Unit name (e.g. Pieces)"
                required
                style={{ width: '100%', padding: '0.65rem 0.85rem', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '0.875rem', boxSizing: 'border-box', outline: 'none' }}
                autoFocus
              />
            </div>

            <div style={{ marginBottom: '1.25rem' }}>
              <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '600', color: 'var(--etpos-text-muted, #374151)', marginBottom: '0.4rem' }}>
                Short Name <span style={{ color: '#ef4444' }}>*</span>
              </label>
              <input
                type="text"
                name="shortName"
                value={unitData.shortName}
                onChange={handleChange}
                placeholder="Short name (e.g. Pc(s))"
                required
                style={{ width: '100%', padding: '0.65rem 0.85rem', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '0.875rem', boxSizing: 'border-box', outline: 'none' }}
              />
            </div>

            <div style={{ marginBottom: 0 }}>
              <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', cursor: 'pointer', fontSize: '0.875rem', color: 'var(--etpos-text, #374151)', fontWeight: '500' }}>
                <input
                  type="checkbox"
                  name="allowDecimal"
                  checked={unitData.allowDecimal}
                  onChange={handleChange}
                  style={{ width: '16px', height: '16px', cursor: 'pointer', accentColor: '#3b82f6' }}
                />
                Allow Decimal
              </label>
            </div>
          </div>

          <div style={{ padding: '1.25rem 1.5rem', borderTop: '1px solid #e2e8f0', background: '#f8fafc', borderBottomLeftRadius: '12px', borderBottomRightRadius: '12px', display: 'flex', justifyContent: 'flex-end', gap: '0.75rem', alignItems: 'center' }}>
            <button type="button" onClick={handleClose} disabled={isSaving} style={{ padding: '0.6rem 1.5rem', background: 'var(--etpos-card, #fff)', color: '#64748b', border: '1px solid #cbd5e1', borderRadius: '8px', cursor: 'pointer', fontWeight: '600', fontSize: '0.875rem' }}>
              Close
            </button>
            <button
              type="submit"
              disabled={isSaving}
              style={{ padding: '0.6rem 1.75rem', background: isSaving ? '#93c5fd' : '#3b82f6', color: 'white', border: 'none', borderRadius: '8px', cursor: isSaving ? 'not-allowed' : 'pointer', fontWeight: '600', fontSize: '0.875rem', boxShadow: '0 2px 4px rgba(59,130,246,0.3)', display: 'flex', alignItems: 'center', gap: '0.4rem' }}
            >
              {isSaving ? 'Saving...' : 'Save'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddUnitModal;
